// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IHideOfferWebsiteRequest,
  THideOfferWebsiteModel,
  IMappers,
  THideOfferWebsiteResponse,
  IHideOfferWebsiteResponse,
  IHideOfferWebsiteResponseError,
} from './types';

export const defaultConfig: THideOfferWebsiteModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'hidden-objects',
  pathApi: '/v1/hide-offer-website/',
  requestType: 'json',
} as THideOfferWebsiteModel;

export function createHideOfferWebsiteModel(parameters: IHideOfferWebsiteRequest): THideOfferWebsiteModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IHideOfferWebsiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IHideOfferWebsiteRequest;
}

export async function fetchHideOfferWebsite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IHideOfferWebsiteOptions<TResponse200, TResponse400>): Promise<
  THideOfferWebsiteResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createHideOfferWebsiteModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IHideOfferWebsiteResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IHideOfferWebsiteResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as THideOfferWebsiteResponse;
}
